import { onPageView, analyticsSearchTerm, analyticsOnClickEvent, onFormResponse, onFormSuccess } from 'analytics/adobe/common-event-listener';
import { googleTracker } from 'analytics/google';
import { getBaseTaxonomy, getISIN } from 'helpers/analytics';

export const analyticsOnPageView = () => {
	setTimeout( () => {
		// AA Event
		onPageView();

		// GA Event.
		const eventAction = `${ getBaseTaxonomy() } : na : page-view : na : ${ getISIN() } : na`;

		googleTracker( eventAction );
	}, 4000 );
};

export const analyticsOnClick = ( event = {}, clickType = '', title = '', GASection = '', isin = '' ) => {
	let GASectionCategory = 'cta-click';

	// No point of wasting analytics trigger call if search keyword criteria not met.
	if ( GASection === 'search' && title.length <= process.env.SEARCH_THRESHOLD_TRIGGER_MIN_LENGTH ) {
		return;
	}

	// If title parameter is not passed, let's extract it from HTML provided in DOM. We'll also clean HTML tags if, any.
	if ( ! title ) {
		title = ( ( event?.target?.innerHTML )?.replace( /<\/?[^>]+(>|$)/g, '' ) || '' ).trim().toLowerCase() || '_';
	}

	// AA Event
	analyticsOnClickEvent( event, clickType, title );

	/**
	 * On funds comparison page we would want to override multiple ISIN with single ISIN only
	 * Ex: Document click, Fund objective toogle, Remove fund from Compare. These events are ISIN specific
	 *
	 * For other events/pages, we will use getISIN()
	 */
	if ( ! isin ) {
		isin = getISIN();
	}

	switch ( GASection ) {
		case 'tabs':
			GASectionCategory = 'tab-click';
			break;
		case 'document':
			GASectionCategory = 'pdf-click';
			break;
		case 'related-articles':
			GASectionCategory = 'link-click';
			break;
		case 'compare-panel':
			if ( ! isin || isin === 'na' ) {
				isin = getISIN( true );
			}

			break;
		case 'table':
			title = title.split( ' - ' );

			GASectionCategory = title?.[2];
			title = `${ title?.[0] } - ${ title?.[1] }`;
			break;
		case 'ribbon':
			title = title.split( ' - ' )?.[0];
			GASectionCategory = ( clickType === 'link' ) ? 'link-click' : 'cta-click';
			break;
		default:
			GASectionCategory = 'cta-click';
			break;
	}

	if ( clickType === 'dropdown' ) {
		GASectionCategory = 'dropdown';
	}

	if ( GASection === 'filters' ) {
		if ( clickType === 'submenu' ) {
			GASectionCategory = event?.collapse_status;
		} else if ( clickType === 'checkbox' ) {
			title = title.split( '_' );

			GASectionCategory = title?.[1];
			title = title?.[0];
		}
	}

	title = ( title ) ? title.toLocaleLowerCase() : '';

	const event_action = `${ getBaseTaxonomy() } : ${ GASection } : ${ GASectionCategory } : ${ title } : ${ isin } : na`;

	googleTracker( event_action );
};

export const analyticsOnForm = ( type = '', sgrID = 'na', formData = {}, status = '' ) => {
	if ( ! formData ) {
		return;
	}

	if ( type === 'success' ) {
		// AA Event
		onFormSuccess( formData );

	} else if ( type === 'response' ) {
		// AA Event
		onFormResponse( sgrID, formData, status );
	}

	// If form submission was successful.
	if ( status && status !== 'na' ) {
		status = `${ status } - `;
	}

	// GA Event.
	let googleFormData = formData;

	delete googleFormData.isinlist;
	googleFormData = JSON.stringify( googleFormData );

	const eventAction = `${ getBaseTaxonomy() } : na : form-submit : ${ status }${ googleFormData } : na : na`;

	googleTracker( eventAction );
};

export const analyticsOnSearch = ( keyword = '', numberOfResults = 0 ) => {
	// No point of wasting analytics trigger call if search keyword criteria not met.
	if ( ! keyword || keyword.length <= process.env.SEARCH_THRESHOLD_TRIGGER_MIN_LENGTH ) {
		return;
	}

	// AA event.
	analyticsSearchTerm( keyword, numberOfResults );

	// GA event.
	const event_action = `${ getBaseTaxonomy() } : search : results : ${ keyword } : ${ numberOfResults } : na`;

	googleTracker( event_action );
};
